import React, { useState, useEffect, useRef } from 'react';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import TabletSidebar from './components/TabletSidebar';
import AuthGate from './components/AuthGate';
import Dashboard from './pages/Dashboard';
import JPSignal from './pages/JPSignal';
import MyAlgos from './pages/MyAlgos';
import Quantiply from './pages/Quantiply';
import Orders from './pages/Orders';
import Settings from './pages/Settings';
import TokenSetup from './pages/TokenSetup';
import OptionChain from './pages/OptionChain';
import IVSurface from './pages/IVSurface';
import TradingJournal from './pages/TradingJournal';
import AMB from './pages/AMB';
import AMB2 from './pages/AMB2';
import AMB3 from './pages/AMB3';
import SuperStraddle from './pages/SuperStraddle';
import SuperStraddle2 from './pages/SuperStraddle2';
import SuperStraddle3 from './pages/SuperStraddle3';
import GammaExposure from './pages/GammaExposure';
import Positioning from './pages/Positioning';
import StraddleTracker from './pages/StraddleTracker';
import HybridConviction from './pages/HybridConviction';
import HybridConvictionM from './pages/HybridConvictionM';
import OIAnalysis from './pages/OIAnalysis';
import OIRide from './pages/OIRide';
import OIRideD from './pages/OIRideD';
import OIRideD1 from './pages/OIRideD1';
import OIRideR from './pages/OIRideR';
import PaperJournal from './pages/PaperJournal';
import OIWalls from './pages/OIWalls';
import OIWalls3x from './pages/OIWalls3x';
import OIWalls2x from './pages/OIWalls2x';
import OIWallsLive from './pages/OIWallsLive';
import OIWalls3xLive from './pages/OIWalls3xLive';
import GEXWallsLive from './pages/GEXWallsLive';
import OIRideDLive from './pages/OIRideDLive';
import OIRideRLive from './pages/OIRideRLive';
import DirectionalTV from './pages/DirectionalTV';
import DirectionalTV1 from './pages/DirectionalTV1';
import Workspace from './pages/Workspace';
import Logs from './pages/Logs';
import GEXWalls from './pages/GEXWalls';
import DashboardM from './pages/DashboardM';
import JPSignalM from './pages/JPSignalM';
import AMBM from './pages/AMBM';
import AMB2M from './pages/AMB2M';
import AMB3M from './pages/AMB3M';
import SuperStraddleM from './pages/SuperStraddleM';
import SuperStraddle2M from './pages/SuperStraddle2M';
import SuperStraddle3M from './pages/SuperStraddle3M';
import OIRideM from './pages/OIRideM';
import OIRideDM from './pages/OIRideDM';
import OIRideD1M from './pages/OIRideD1M';
import OIRideRM from './pages/OIRideRM';
import OIWallsM from './pages/OIWallsM';
import OIWalls3xM from './pages/OIWalls3xM';
import OIWalls2xM from './pages/OIWalls2xM';
import OIWallsLiveM from './pages/OIWallsLiveM';
import OIWalls3xLiveM from './pages/OIWalls3xLiveM';
import GEXWallsLiveM from './pages/GEXWallsLiveM';
import OIRideDLiveM from './pages/OIRideDLiveM';
import OIRideRLiveM from './pages/OIRideRLiveM';
import DirectionalTVM from './pages/DirectionalTVM';
import DirectionalTV1M from './pages/DirectionalTV1M';
import GEXWallsM from './pages/GEXWallsM';
import GammaExposureM from './pages/GammaExposureM';
import PositioningM from './pages/PositioningM';
import StraddleTrackerM from './pages/StraddleTrackerM';
import QuantiplyM from './pages/QuantiplyM';
import OrdersM from './pages/OrdersM';
import TokenSetupM from './pages/TokenSetupM';
import MobileNav from './components/MobileNav';
import AlertRibbon from './components/AlertRibbon';
import './App.css';
import { LiveDataProvider } from './LiveDataContext';

var MOBILE_PAGE_ORDER = ['dashboard','jpsignal','quantiply','amb','amb2','amb3','super_straddle','super_straddle_2','super_straddle_3','hybrid','gex','positioning','oiride','oirided','oirided1','oirider','oiwalls','oiwalls3x','oiwalls2x','oiwalls_live','oiwalls3x_live','gexwalls','gexwalls_live','oiride_d_live','oiride_r_live','directional_tv','directional_tv1','straddle','orders','token'];


// Nav visibility, set on the desktop Settings page and stored on the SERVER
// (/ui-config) so one toggle reaches every device. localStorage is per-device,
// which is why a desktop toggle could never reach the phone.
//
// Three properties this deliberately guarantees:
//   1. NO RENDER DELAY — the initial value is read synchronously from the
//      localStorage cache, so the menu draws on the first frame. Nothing ever
//      waits on the network to paint a nav.
//   2. NO HANG — the fetch is fire-and-forget with a 4s abort. If the backend
//      is slow or down, the cached list simply stays; nothing blocks on it.
//   3. NO RECURRING LOAD — one fetch per mount, no polling. A toggle change
//      arrives by event carrying the new list, so it costs no extra request.
function useHiddenNav() {
  var read = function () {
    try {
      var a = JSON.parse(localStorage.getItem('algrok_nav_hidden') || '[]');
      return Array.isArray(a) ? a.filter(function (x) { return x !== 'settings'; }) : [];
    } catch (e) { return []; }
  };
  var hs = useState(read);
  var hidden = hs[0], setHidden = hs[1];
  useEffect(function () {
    var alive = true;
    var timer = null;
    var pull = function () {
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      if (timer) clearTimeout(timer);
      timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 4000) : null;
      fetch('https://api.algrok.com/ui-config', ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (timer) { clearTimeout(timer); timer = null; }
          if (!alive || !d) return;          // 401 before login lands here
          var a = Array.isArray(d.nav_hidden) ? d.nav_hidden : [];
          a = a.filter(function (x) { return x !== 'settings'; });
          setHidden(a);
          try { localStorage.setItem('algrok_nav_hidden', JSON.stringify(a)); } catch (e) { /* ignore */ }
        })
        .catch(function () {
          if (timer) { clearTimeout(timer); timer = null; }
          // Keep the cached list. Never clear it on failure — an unreachable
          // backend must not silently un-hide everything.
        });
    };
    pull();
    var onChange = function (e) {
      if (e && e.detail && Array.isArray(e.detail)) {
        setHidden(e.detail.filter(function (x) { return x !== 'settings'; }));
      }
    };
    // The mount fetch above happens BEFORE login on a cold load, so it 401s and
    // returns nothing. AuthGate fires this the moment the session is valid —
    // on a fresh login and when an existing token is found — so the list
    // arrives without waiting for the next page load.
    var onAuthed = function () { pull(); };
    window.addEventListener('algrok-nav-changed', onChange);
    window.addEventListener('algrok-authenticated', onAuthed);
    return function () {
      alive = false;
      if (timer) clearTimeout(timer);
      window.removeEventListener('algrok-nav-changed', onChange);
      window.removeEventListener('algrok-authenticated', onAuthed);
    };
  }, []);
  return hidden;
}

function useDevice() {
  var get = function() {
    var w = window.innerWidth;
    var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    if (w < 768) return 'mobile';
    if (isTouch && w <= 1366) return 'tablet';
    if (w <= 1024) return 'tablet';
    return 'desktop';
  };
  var [device, setDevice] = useState(get());
  useEffect(function() {
    var onResize = function() { setDevice(get()); };
    window.addEventListener('resize', onResize);
    return function() { window.removeEventListener('resize', onResize); };
  }, []);
  return device;
}

export default function App() {
  var device = useDevice();
  var isMobile = device === 'mobile';
  var isTablet = device === 'tablet';
  var [activePage, setActivePage] = useState('dashboard');
  var hiddenNav = useHiddenNav();
  // Swipe order excludes hidden pages, so a swipe never lands on something
  // that is not in the menu. Falls back to the full list if everything is
  // hidden, which would otherwise break swiping entirely.
  var swipeOrder = MOBILE_PAGE_ORDER.filter(function (p) { return hiddenNav.indexOf(p) === -1; });
  if (!swipeOrder.length) swipeOrder = MOBILE_PAGE_ORDER;
  useEffect(function () {
    // If the page you are looking at gets hidden, move to Dashboard rather
    // than leave you on an unreachable page with broken swipe maths.
    if (activePage !== 'dashboard' && hiddenNav.indexOf(activePage) > -1) {
      setActivePage('dashboard');
    }
  }, [hiddenNav, activePage]);
  var [sidebarOpen, setSidebarOpen] = useState(false);

  var swipeContainerRef = useRef(null);
  var [swipeContainerEl, setSwipeContainerEl] = useState(null);
  var attachSwipeContainer = function(el) {
    swipeContainerRef.current = el;
    setSwipeContainerEl(el);
  };
  var swipeState = useRef({ startX: 0, startY: 0, dx: 0, locked: false, isHorizontal: false, active: false });
  var [swipeTarget, setSwipeTarget] = useState(null);

  useEffect(function() {
    var el = swipeContainerEl;
    if (!el) return;

    function getEls() {
      return el.querySelectorAll('[data-swipe-page]');
    }
    function setTransform(pages, dx, animate) {
      var w = window.innerWidth;
      pages.forEach(function(p) {
        var off = parseInt(p.getAttribute('data-swipe-offset') || '0');
        p.style.transition = animate ? 'transform 0.3s cubic-bezier(0.2, 0.9, 0.3, 1)' : 'none';
        p.style.willChange = animate ? 'auto' : 'transform';
        p.style.transform = 'translate3d(' + (off * w + dx) + 'px,0,0)';
      });
    }

    function onStart(e) {
      if (swipeState.current.active) return;
      var t = e.touches[0];
      swipeState.current = { startX: t.clientX, startY: t.clientY, dx: 0, locked: false, isHorizontal: false, active: true };
    }

    function onMove(e) {
      var s = swipeState.current;
      if (!s.active) return;
      var t = e.touches[0];
      var dx = t.clientX - s.startX;
      var dy = t.clientY - s.startY;

      if (!s.locked && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        s.locked = true;
        s.isHorizontal = Math.abs(dx) > Math.abs(dy);
        if (!s.isHorizontal) {
          s.active = false;
          return;
        }
      }
      if (!s.locked || !s.isHorizontal) return;

      e.preventDefault();
      var idx = swipeOrder.indexOf(activePage);
      if (dx > 0 && idx <= 0) dx = dx * 0.2;
      if (dx < 0 && idx >= swipeOrder.length - 1) dx = dx * 0.2;
      s.dx = dx;
      setTransform(getEls(), dx, false);
    }

    function onEnd(e) {
      var s = swipeState.current;
      if (!s.active) return;
      s.active = false;
      if (!s.isHorizontal) return;

      var w = window.innerWidth;
      var idx = swipeOrder.indexOf(activePage);
      var pages = getEls();

      if (Math.abs(s.dx) > w * 0.3) {
        var dir = s.dx > 0 ? -1 : 1;
        var newIdx = idx + dir;
        if (newIdx >= 0 && newIdx < swipeOrder.length) {
          setTransform(pages, s.dx > 0 ? w : -w, true);
          setTimeout(function() {
            setSwipeTarget({ pageId: swipeOrder[newIdx] });
          }, 300);
          return;
        }
      }
      setTransform(pages, 0, true);
      setTimeout(function() {
        pages.forEach(function(p) { p.style.transition = 'none'; p.style.willChange = 'auto'; });
      }, 310);
    }

    el.addEventListener('touchstart', onStart, { passive: true });
    el.addEventListener('touchmove', onMove, { passive: false });
    el.addEventListener('touchend', onEnd, { passive: true });
    return function() {
      el.removeEventListener('touchstart', onStart);
      el.removeEventListener('touchmove', onMove);
      el.removeEventListener('touchend', onEnd);
    };
  }, [activePage, swipeContainerEl]);

  useEffect(function() {
    if (swipeTarget) {
      setActivePage(swipeTarget.pageId);
      setSwipeTarget(null);
    }
  }, [swipeTarget, setActivePage]);

  useEffect(function() {
    function handler(e) { if (e.detail) setActivePage(e.detail); }
    window.addEventListener('navigate-to', handler);
    return function() { window.removeEventListener('navigate-to', handler); };
  }, [setActivePage]);

  useEffect(function() {
    var params = new URLSearchParams(window.location.search);
    var requestToken = params.get('request_token');
    var status = params.get('status');
    if (requestToken && status === 'success') {
      window.history.replaceState({}, '', '/');
      sessionStorage.setItem('pending_request_token', requestToken);
      setActivePage('token');
    }
  }, []);

  var navigateTo = function(page) {
    setActivePage(page);
    if (isMobile) setSidebarOpen(false);
  };

  /* ── Mobile ─────────────────────────────── */
  if (isMobile) {
    var mobilePages = {
      dashboard: <DashboardM />,
      jpsignal:  <JPSignalM />,
      quantiply: <QuantiplyM />,
      amb:       <AMBM />,
      amb2:      <AMB2M />,
      amb3:      <AMB3M />,
      super_straddle:   <SuperStraddleM />,
      super_straddle_2: <SuperStraddle2M />,
      super_straddle_3: <SuperStraddle3M />,
      oiride:    <OIRideM />,
      oirided:   <OIRideDM />,
      oirided1:  <OIRideD1M />,
      oirider:   <OIRideRM />,
      oiwalls:   <OIWallsM />,
      oiwalls3x: <OIWalls3xM />,
      oiwalls2x: <OIWalls2xM />,
      oiwalls_live: <OIWallsLiveM />,
      oiwalls3x_live: <OIWalls3xLiveM />,
      gexwalls_live: <GEXWallsLiveM />,
      oiride_d_live: <OIRideDLiveM />,
      oiride_r_live: <OIRideRLiveM />,
      directional_tv: <DirectionalTVM />,
      directional_tv1: <DirectionalTV1M />,
      gexwalls:  <GEXWallsM />,
      hybrid:    <HybridConvictionM />,
      gex:       <GammaExposureM />,
      positioning: <PositioningM />,
      straddle:  <StraddleTrackerM />,
      orders:    <OrdersM />,
      token:     <TokenSetupM />,
    };

    return (
      <AuthGate>
      <LiveDataProvider>
      <div style={{ height:'100vh', overflow:'hidden', background:'#05080f' }}>
        <style>{'*::-webkit-scrollbar{display:none}*{scrollbar-width:none;-ms-overflow-style:none}'}</style>
        <AlertRibbon />
        <div ref={attachSwipeContainer} style={{ position:'relative', width:'100%', height:'calc(100vh - 52px)', overflow:'hidden', touchAction:'pan-y' }}>
          {function() {
            var currentIdx = swipeOrder.indexOf(activePage);
            var w = window.innerWidth;
            // MUST be swipeOrder, not MOBILE_PAGE_ORDER. currentIdx above is an
            // index into swipeOrder; mapping the unfiltered list here mixes two
            // index spaces, so `offset` is wrong as soon as anything is hidden —
            // the menu filtered correctly while the swipe did not.
            return swipeOrder.map(function(pageId, i) {
              var offset = i - currentIdx;
              if (offset < -1 || offset > 1) return null;
              var pageStyle = { position:'absolute', top:0, left:0, width:'100%', height:'100%', overflow:'auto', WebkitOverflowScrolling:'touch', backfaceVisibility:'hidden', transform:'translate3d('+(offset*w)+'px,0,0)' };
              return <div key={pageId} data-swipe-page={pageId} data-swipe-offset={offset} style={pageStyle}>{mobilePages[pageId]}</div>;
            });
          }()}
        </div>
        <MobileNav activePage={activePage} setActivePage={setActivePage} hidden={hiddenNav} />
      </div>
      </LiveDataProvider>
      </AuthGate>
    );
  }

  /* ── Shared page map ────────────────────── */
  var pages = {
    dashboard  : <Dashboard />,
    jpsignal   : <JPSignal />,
    myalgos    : <MyAlgos />,
    quantiply  : <Quantiply />,
    orders     : <Orders />,
    settings   : <Settings />,
    token      : <TokenSetup />,
    optionchain: <OptionChain />,
    ivsurface  : <IVSurface />,
    journal    : <TradingJournal />,
    amb        : <AMB />,
    amb2       : <AMB2 />,
    amb3       : <AMB3 />,
    super_straddle   : <SuperStraddle />,
    super_straddle_2 : <SuperStraddle2 />,
    super_straddle_3 : <SuperStraddle3 />,
    hybrid     : <HybridConviction />,
    gex        : <GammaExposure />,
    positioning: <Positioning />,
    oi         : <OIAnalysis />,
    oiride     : <OIRide />,
    oirided    : <OIRideD />,
    oirided1   : <OIRideD1 />,
    oirider    : <OIRideR />,
    paper_journal: <PaperJournal />,
    oiwalls    : <OIWalls />,
    oiwalls3x  : <OIWalls3x />,
    oiwalls2x  : <OIWalls2x />,
    oiwalls_live: <OIWallsLive />,
    oiwalls3x_live: <OIWalls3xLive />,
    gexwalls_live: <GEXWallsLive />,
    oiride_d_live: <OIRideDLive />,
    oiride_r_live: <OIRideRLive />,
    directional_tv: <DirectionalTV />,
    directional_tv1: <DirectionalTV1 />,
    workspace: <Workspace />,
    logs       : <Logs />,
    gexwalls   : <GEXWalls />,
    straddle   : <StraddleTracker />,
  };

  /* ── iPad App Shell ─────────────────────── */
  if (isTablet) {
    return (
      <AuthGate>
      <LiveDataProvider>
      <div style={{
        height: '100vh', display: 'flex', background: '#030712',
        overflow: 'hidden',
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}>
        <style>{
          '*::-webkit-scrollbar{width:4px;height:4px}' +
          '*::-webkit-scrollbar-track{background:transparent}' +
          '*::-webkit-scrollbar-thumb{background:rgba(26,45,74,0.4);border-radius:4px}' +
          '*::-webkit-scrollbar-thumb:hover{background:rgba(26,45,74,0.7)}'
        }</style>

        <TabletSidebar activePage={activePage} setActivePage={navigateTo} hidden={hiddenNav} />

        <div style={{
          flex: 1, display: 'flex', flexDirection: 'column',
          background: '#080e1d',
          borderRadius: '14px 0 0 14px',
          overflow: 'hidden',
          marginLeft: -1,
        }}>
          <AlertRibbon />
          {pages[activePage] || <Dashboard />}
        </div>
      </div>
      </LiveDataProvider>
      </AuthGate>
    );
  }

  /* ── Desktop ────────────────────────────── */
  return (
    <AuthGate>
    <LiveDataProvider>
    <div className="app-shell">
      <Sidebar activePage={activePage} setActivePage={navigateTo} collapsed={false} setCollapsed={function(){}} mobileOpen={sidebarOpen} isMobile={false} hidden={hiddenNav} />
      <div className="main-area">
        <AlertRibbon />
        <TopBar activePage={activePage} onMenuClick={function() { setSidebarOpen(!sidebarOpen); }} isMobile={false} />
        <div className="page-content">
          {pages[activePage] || <Dashboard />}
        </div>
      </div>
    </div>
    </LiveDataProvider>
    </AuthGate>
  );
}
